import { Component, OnInit, ViewChild, AfterViewInit, ElementRef, ChangeDetectorRef } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, MatSortable } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { fromEvent, merge } from "rxjs";
import { debounceTime, distinctUntilChanged, tap } from "rxjs/operators";
import { AddEditCountriesComponent } from './add-edit-countries/add-edit-countries.component';
import { CountriesDataSource } from "../services/data-sources/countries.datasource";
import { CountriesService } from "../services/countries.service";
import { ConfirmPopupComponent } from "../common/confirm-popup/confirm-popup.component";
import { SelectionModel } from '@angular/cdk/collections';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from '../services/auth/auth.service';

@Component({
    selector: 'app-countries',
    templateUrl: './countries.component.html',
    styleUrls: ['./countries.component.scss'],
    standalone: false
})
export class CountriesComponent implements OnInit, AfterViewInit {

	displayedColumns: string[] = [
		"sn", "select", "id",
		'name',
		'code',
		'icon',
		'actions',
	];
	selection = new SelectionModel<number>(true, []);
	bulkAction = '';
	dataSource!: CountriesDataSource;
	currentPageCount = 0;
	count = 0;
	authUser: any;

	@ViewChild(MatPaginator) paginator!: MatPaginator;
	@ViewChild(MatSort) sort!: MatSort;
	@ViewChild('search') search!: ElementRef;

	constructor(
		private countriesService: CountriesService, public dialog: MatDialog,
		private _snackBar: MatSnackBar, private ref: ChangeDetectorRef,
		public authService: AuthService,
	) {
		this.dataSource = new CountriesDataSource(this.countriesService);

		this.authService.user.subscribe((res: any) => {
			this.authUser = res.user;
		});
	}
	ngOnInit() {
		this.dataSource.currentPageCount$.subscribe(currentPageCount => {
			this.currentPageCount = currentPageCount;
		});
		this.dataSource.count$.subscribe(count => {
			this.count = count;
		});
	}
	ngAfterViewInit() {
		fromEvent(this.search.nativeElement, 'keyup')
			.pipe(
				debounceTime(150),
				distinctUntilChanged(),
				tap(() => {
					this.paginator.pageIndex = 0;

					this.loadPage();
				})
			)
			.subscribe();

		merge(this.sort.sortChange, this.paginator.page)
			.pipe(
				tap(() => this.loadPage())
			)
			.subscribe();
		this.sort.sort(({ id: 'name', start: 'desc' }) as MatSortable);
		this.ref.detectChanges();
	}

	/** Whether the number of selected elements matches the total number of rows. */
	isAllSelected() {
		return this.selection.selected.length === this.currentPageCount;
	}

	/** Selects all rows if they are not all selected; otherwise clear selection. */
	masterToggle() {
		this.isAllSelected() ?
			this.selection.clear() :
			this.dataSource.getList().forEach(row => this.selection.select(row.id));
	}

	loadPage() {
		this.dataSource.list(
			{
				search: this.search.nativeElement.value,
			},
			this.sort.active,
			this.sort.direction,
			this.paginator.pageIndex + 1,
			this.paginator.pageSize);
	}

	addEdit(id: number | undefined = undefined) {

		let options;
		if (id) {
			const countries = this.dataSource.getList().find(x => x.id == id);
			options = {
				maxWidth: '767px',
				width: '100%',
				data: {
					id: 'add-country',
					countries: countries,
				}
			}
		}
		else options = {
			maxWidth: '767px',
			width: '100%',
			data: {
				id: 'add-country',
			}
		}
		const dialogRef = this.dialog.open(AddEditCountriesComponent, options);

		dialogRef.afterClosed().subscribe(result => {
			if (result) this.loadPage();
		});
	}

	delete(id: number) {
		const dialogRef = this.dialog.open(ConfirmPopupComponent, {
			id: 'delete-country',
			maxWidth: '480px',
			width: '100%',
			data: {
				title: 'Confirmation',
				message: 'Are you sure you want to delete this country?'
			}
		});

		dialogRef.componentInstance.onConfirm.subscribe(() => {
			this.countriesService.destroy(id).subscribe(() => {
				dialogRef.close()
				this.loadPage();
			});
		});
	}
	openStatusChangeDialog() {
		const dialogRef = this.dialog.open(ConfirmPopupComponent, {
			id: 'change-status-country',
			maxWidth: '480px',
			width: '100%',
			data: {
				title: 'Confirmation',
				message: 'Are you sure you want to delete this country?'
			}
		});

		dialogRef.afterClosed().subscribe(result => {
			if (result) {
				alert('w');
			}
		});
	}

	bulkActionConfirm() {
		if (this.bulkAction === '') {
			return;
		}
		if (this.selection.selected.length === 0) {
			this._snackBar.open('Select some records to perform this action.', 'Dismiss');
			setTimeout(() => {
				this.bulkAction = '';
			}, 500)
			return;
		}
		const dialogRef = this.dialog.open(ConfirmPopupComponent, {
			id: 'bulk-action',
			maxWidth: '480px',
			width: '100%',
			data: {
				title: 'Confirmation',
				message: 'Are you sure you want to ' + (
					this.bulkAction === 'delete' ? 'delete' : ''
				) + ' selected records ?'
			}
		});

		dialogRef.componentInstance.onConfirm.subscribe(() => {
			this.countriesService.bulkDelete(this.selection.selected).subscribe(() => {
				dialogRef.close();
				this.selection.clear();
				this.loadPage();
			});
		});
		dialogRef.afterClosed().subscribe(() => {
			this.bulkAction = '';
		});
	}

}
